import * as React from 'react';
import { SimpleInventoryWithLinkedMaterialInfo } from '../../../store/Models/Inventories/SimpleInventory';
import { NavPillsDetail } from '../NavPillsDetail';
import * as Table from '../ToxnotReactTable';

enum TableSelectedType {
    Materials = 0,
    Products = 1
}

interface ProductMaterialTableState {
    currentlySelected: TableSelectedType;
}

/*
 * Renders both a Materials Table and a Products Table for a user's inventories. A user
 * can toggle a select between each. Keep in mind some operations like selection will 
 * containt the selection of both materials and products.
 */
export class ProductMaterialTable extends React.PureComponent<Table.ToxnotReactTableProps<SimpleInventoryWithLinkedMaterialInfo>, ProductMaterialTableState> {

    // ===============================================================================

    constructor(props: Table.ToxnotReactTableProps<SimpleInventoryWithLinkedMaterialInfo>) {
        super(props);

        this.state = {
            currentlySelected: TableSelectedType.Materials
        }
    }

    // ===============================================================================

    public render() {
        const materials = this.props.allRowModels.filter(r => r.isComponent);
        const products = this.props.allRowModels.filter(r => !r.isComponent);

        const propsCopy = { ...this.props };
        propsCopy.allRowModels = this.state.currentlySelected === TableSelectedType.Materials ? materials : products;

        return (
            <div className="materials-products-table-container">
                <NavPillsDetail localizedNavTitles={[this.props.localizer.localizeString("Materials"), this.props.localizer.localizeString("Products")]} onNavIndexChanged={this.navPills_navIndexChanged} />
                <Table.ToxnotReactTable
                    {...propsCopy}
                />
            </div>
        );
    }

    // ===============================================================================

    private navPills_navIndexChanged = (navIndex: number) => {
        this.setState({
            currentlySelected: navIndex
        });
    }
}
